import { render, staticRenderFns } from "./UpdateIssue.vue?vue&type=template&id=8e318224&"
import script from "./UpdateIssue.vue?vue&type=script&lang=js&"
export * from "./UpdateIssue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports